import styled from "styled-components";
import { ReactComponent as LogoSvg } from "../assets/PMG logo-01-1.svg";
import { ReactComponent as LogoWhite } from "../assets/PMG logo-02-2.svg";
import { ReactComponent as IconMenu } from "../assets/icon-menu.svg";
import { ReactComponent as Dashboard } from "../assets/icon-dashboard-normal.svg";
import { ReactComponent as Contact } from "../assets/icon-contact-normal.svg";
import { ReactComponent as Employee } from "../assets/icon-employee-normal.svg";
import { ReactComponent as Templates } from "../assets/icon-template-normal.svg";
import { ReactComponent as Master } from "../assets/icon-master-normal.svg";
import { ReactComponent as Setting } from "../assets/icon-setting-normal.svg";
import { ReactComponent as Report } from "../assets/icon-report-normal.svg";
import { ReactComponent as Edit } from "../assets/icon-edit.svg";
import { ReactComponent as Transfer } from "../assets/icon-transfer.svg";
import { ReactComponent as WhiteTransfer } from "../assets/icon-transfer-white.svg";
import { ReactComponent as Calender } from "../assets/icon-input-calendar.svg";
import { ReactComponent as SortDesc } from "../assets/icon-sort.svg";
import { ReactComponent as SortAsce } from "../assets/icon-sort-asce.svg";
import { ReactComponent as Filter } from "../assets/icon-filter.svg";
import { ReactComponent as Unlock } from "../assets/icon-unblock.svg";

export const Logo = styled(LogoSvg)`
  height: ${props => (props.isResponsive ? "52px" : "")};
  width: 130px;
  margin-top: ${props => (props.marginLeft ? "-10px" : "-10px")};
  //margin-top: -6px;
  margin-left: ${props => (props.marginLeft ? "0px" : "10px")};
  margin-right: ${props => (props.marginLeft ? "10px" : "11px")};
  //display: ${props => (props.noneClass ? "none" : "block")};
`;

export const LogoSvgWhite = styled(LogoWhite)`
  height: 55px;
  width: 130px;
`;

export const HamburgerIcon = styled(IconMenu)`
  margin-left: 20px;
  cursor: pointer;
  #bg {
    fill: #${props => (props.active === "true" ? "efefef" : "fff")};
  }
`;

HamburgerIcon.displayName = "HamburgerIcon";

export const Strip = styled.div`
  height: 70px;
  background: ${/* istanbul ignore next */ ({ theme }) => theme.palette.LIGHT};
  border-bottom: solid 1px ${({ theme }) => theme.palette.LIGHTGREY1};
  display: flex;
  flex-direction: ${({ flexDirection }) => flexDirection || "row"};
  align-items: ${({ alignItems }) => alignItems || "flex-start"};
  justify-content: ${({ justify }) => justify || "flex-start"};
`;

export const Button = styled.button`
  border: solid 1px ${({ color, theme }) => color || theme.palette.LIGHTGREY4};
  padding: 5px 15px;
  font-family: ${({ theme }) => theme.fontFamily.BOLD};
  font-size: ${({ theme }) => theme.fontSize.MEDIUM};
  border-radius: 4px;
  color: ${({ color, theme }) => color || theme.palette.SECONDARY};
  background: ${({ background, theme }) => background || theme.palette.WHITE};
  display: flex;
  align-items: center;
  position: relative;
  cursor: pointer;
  &:disabled {
    opacity: 0.5;
    cursor: default;
  }
`;

export const CancelButton = styled.button`
  border: 1px solid ${({ theme }) => theme.palette.SECONDARY};
  font-family: ${({ theme }) => theme.fontFamily.BOLD};
  font-size: ${({ theme }) => theme.fontSize.MEDIUM};
  border-radius: 4px;
  color: ${({ color, theme }) => color || theme.palette.SECONDARY};
  background: transparent;
  position: relative;
  cursor: pointer;
  padding: 8px 15px;
  align-self: center;
  &:disabled {
    opacity: 0.5;
    cursor: default;
  }
`;

export const NoStyleButton = styled.button`
  border: none;
  font-family: ${({ theme }) => theme.fontFamily.BOLD};
  font-size: ${({ theme }) => theme.fontSize.MEDIUM};
  color: ${({ color, theme }) => color || theme.palette.SECONDARY};
  background: transparent;
  position: relative;
  cursor: pointer;
  padding: 8px 15px;
  align-self: center;
  &:disabled {
    opacity: 0.5;
    cursor: default;
  }
  &:hover {
    color: none;
  }
`;

export const NoStyleButton2 = styled.button`
  border: none;
  font-family: ${({ theme }) => theme.fontFamily.BOLD};
  font-size: ${({ theme }) => theme.fontSize.MEDIUM};
  color: ${({ color, theme }) => color || theme.palette.PRIMARY};
  background: transparent;
  position: relative;
  cursor: pointer;
  align-self: center;
  &:disabled {
    opacity: 0.5;
    cursor: default;
  }
  &:hover {
    color: ${({ color, theme }) => color || theme.palette.PRIMARY};
  }
`;

export const WhiteButton = styled(Button)`
  background: ${({ theme }) => theme.palette.WHITE};
  color: ${({ theme }) => theme.palette.BLACK};
  border-color: ${({ theme }) => theme.palette.LIGHTGREY1};
  font-family: ${({ theme }) => theme.fontFamily.REGULAR};
  margin-right: 15px;
  padding: 8px 15px;
  align-self: center;
  border-radius: 25px;
  .icon {
    display: flex;
    margin-right: 5px;
    margin-top: -2px;
  }
`;

export const GrayButton = styled(Button)`
  background: ${({ theme }) => theme.palette.WHITE};
  color: ${({ theme }) => theme.palette.BLACK};
  border-color: ${({ theme }) => theme.palette.LIGHTGREY1};
  font-family: ${({ theme }) => theme.fontFamily.REGULAR};
  margin-right: 15px;
  padding: 8px 15px;
  align-self: center;
  border-radius: 25px;
  width: 100%;
  .icon {
    display: flex;
    margin-right: 5px;
    margin-top: -2px;
  }
`;

export const CloseButtonPopup = styled(Button)`
  border: none;
  padding: 0;
  position: absolute;
  right: -11px;
  top: -10px;
  background: ${/* istanbul ignore next */ ({ theme }) => theme.palette.BLACK};
  color: ${/* istanbul ignore next */ ({ theme }) => theme.palette.WHITE};
  border: solid 2px
    ${/* istanbul ignore next */ ({ theme }) => theme.palette.WHITE};
  border-radius: 50%;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.75);
  z-index: 1;
`;

export const SearchInput = styled.input`
  width: 296px;
  height: 26px;
  border: none;
  font-size: ${({ theme }) => theme.fontSize.MEDIUM};
  &:focus {
    outline: none;
  }
  @media (max-width: 1024px) {
    width: 150px;
  }
`;

export const SegmentButton = styled(Button)`
  background: ${({ selected, theme }) =>
    selected ? theme.palette.SELECTED : theme.palette.LIGHTGREY3};
  color: ${({ selected, theme }) =>
    selected ? theme.palette.WHITE : theme.palette.DARKGREY2};
  border: ${({ selected, theme }) =>
    selected ? theme.palette.SELECTED : theme.palette.SELECTED};
  padding: 12px 15px;
  border-radius: 10px;
  margin-right: 10px;
`;

export const InputLabel = styled.label`
  color: ${({ theme }) => theme.palette.DARK_GREY};
  font-size: ${({ theme }) => theme.fontSize.MEDIUM};
`;

export const DashboardIcon = styled(Dashboard)``;
export const ContactIcon = styled(Contact)``;
export const EmployeeIcon = styled(Employee)``;
export const TemplatesIcon = styled(Templates)``;
export const MasterIcon = styled(Master)``;
export const SettingIcon = styled(Setting)``;
export const ReportIcon = styled(Report)``;
export const CalenderIcon = styled(Calender)``;
export const EditIcon = styled(Edit)``;
export const TransferIcon = styled(Transfer)``;
export const WhiteTransferIcon = styled(WhiteTransfer)``;
export const SortIconDesc = styled(SortDesc)``;
export const SortIconAsce = styled(SortAsce)``;
export const FilterIcon = styled(Filter)``;
export const UnlockIcon = styled(Unlock)``;
